import { createAction } from 'redux-actions';

import { NotificationType } from '@ts/notifications.types';

export const addNotification =
  createAction<(arg: NotificationType) => NotificationType>('ADD_NOTIFICATION');
export const removeNotification = createAction<string>('REMOVE_NOTIFICATION');
